<template>
  <div class="results-controls">
    <b-row>
      <b-col>
        <div class="results-controls__bar">
          <div class="results-controls__bar-left">
            <sorting-select
              :sort="sort"
              @order="(value) => $emit('order', value)"
            />
            <availability-toggle
              :active="active_filters.filter_availability"
              :is_known="availability_is_known"
              @toggle="(value) => $emit('filter', { key: 'availability', filters: value })"
            />
          </div>
          <filter-modal
            :filters="filters"
            :filtering="filtering"
            :update_key="update_key"
            @filter="on_modal_filter"
          />
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <active-filters
          :filters="filters"
          :update_key="update_key"
          @filter="on_modal_filter"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js'
import { build_filters } from '@alpitour/utilities/results-filters'
import SortingSelect from './sorting-select.vue'
import AvailabilityToggle from './availability-toggle.vue'
import ActiveFilters from './active-filters.vue'
import FilterModal from './filter-modal.vue'

export default {
  name: "results-controls",
  components: {
    'sorting-select': SortingSelect,
    'availability-toggle': AvailabilityToggle,
    'active-filters': ActiveFilters,
    'filter-modal': FilterModal,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    filtered: {
      type: Array,
      default: () => [],
    },
    statics: {
      type: Object,
      default: () => ({}),
    },
    sort: {
      type: String,
      default: '',
    },
    active_filters: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('liveat', ['is_only_stay_package']),
    availability_is_known() {
      const { is_known = false } = this.get_availability()
      return is_known
    },
  },
  data() {
    return {
      filters: {},
      filtering: false,
      update_key: 0,
    }
  },
  mounted() {
    this.refresh_filters()
  },
  watch: {
    filtered(new_value, old_value) {
      if (new_value.length !== old_value.length) {
        this.refresh_filters()
        this.update_key = this.update_key + 1
      }
    },
  },
  methods: {
    refresh_filters() {
      this.filters = build_filters({
        products: this.products,
        filtered: this.filtered,
        statics: this.statics,
        active_filters: this.active_filters,
        is_only_stay: this.is_only_stay_package,
      })
    },

    on_modal_filter({ key }) {
      this.filtering = true

      let filters
      if (key === 'availability') {
        // handled by availability-toggle, shouldn't reach here
        return
      } else if (!this.filters[key]) {
        filters = []
      } else {
        filters = this.filters[key]
          .filter((f) => f.selected)
          .map((f) => f.value)
      }

      this.$emit('filter', { key, filters })

      setTimeout(() => {
        this.filtering = false
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.results-controls {
  &__bar {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: $grid-gutter-width / 2;

    @include media-breakpoint-up(sm) {
      align-items: center;
    }
  }

  &__bar-left {
    @include media-breakpoint-up(sm) {
      display: flex;
      align-items: center;
      gap: $grid-gutter-width / 6;
    }
  }
}
</style>
